import React, { useState } from "react";
import { Video, Activity } from "lucide-react";
import UserWorkshops from "./UserWorkshops";

const TABS = [
	{
		key: "workshop",
		tab: "workshops",
		icon: Video,
		tabLabel: "Workshops",
		label: "Workshop",
		labelPlural: "Workshops",
	},
	{
		key: "mobility",
		tab: "mobility",
		icon: Activity,
		tabLabel: "Mobility",
		label: "Mobility Video",
		labelPlural: "Mobility Videos",
	},
];

/**
 * User-facing "Video Library" with a tabbed menu (Workshops / Mobility).
 * Each tab shows published videos for its category via UserWorkshops.
 */
const UserVideoLibrary = ({ workshops, loading }) => {
	const [activeSubTab, setActiveSubTab] = useState("workshops");

	const activeTabDef = TABS.find((t) => t.tab === activeSubTab) || TABS[0];

	return (
		<div style={{ maxWidth: "100%", overflow: "hidden" }}>
			{/* Tabbed menu */}
			<ul
				className="nav nav-tabs mb-3"
				style={{
					flexWrap: "nowrap",
					borderBottom: "none",
					marginBottom: 0,
					gap: "0.5rem",
				}}
			>
				{TABS.map(({ tab, icon: Icon, tabLabel }) => {
					const isActive = activeSubTab === tab;
					return (
						<li key={tab} className="nav-item" style={{ flex: "1 1 0" }}>
							<button
								className={`nav-link ${isActive ? "active" : ""} w-100 text-center`}
								onClick={() => setActiveSubTab(tab)}
								style={
									isActive
										? {
												backgroundColor: "#d15a36",
												borderColor: "#d15a36",
												color: "#fff",
												fontSize: "0.85rem",
												padding: "0.5rem 0.25rem",
												borderRadius: "0.375rem",
											}
										: {
												backgroundColor: "rgba(209, 90, 54, 0.15)",
												borderColor: "transparent",
												color: "#fff",
												fontSize: "0.85rem",
												padding: "0.5rem 0.25rem",
												borderRadius: "0.375rem",
											}
								}
							>
								<Icon size={14} className="me-1" />
								{tabLabel}
							</button>
						</li>
					);
				})}
			</ul>

			{/* Active tab content */}
			<UserWorkshops
				key={activeTabDef.key}
				workshops={workshops}
				loading={loading}
				category={activeTabDef.key}
				label={activeTabDef.label}
				labelPlural={activeTabDef.labelPlural}
			/>
		</div>
	);
};

export default UserVideoLibrary;
